import { useFormik } from 'formik';

import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import type { SenderInfoUT } from '@features/delivery/add-sender-info-ut';

import { schema } from '@features/delivery/add-sender-info-ut/lib';

import { setDeliverySenderInfoUt } from './actions';

type AddSenderInfoUtProps = {
  initialValues: SenderInfoUT;
};

const useAddSenderInfo = ({ initialValues }: AddSenderInfoUtProps) => {
  const dispatch = useDispatch();

  const [isValid, setIsValid] = useState(false);

  const form = useFormik<SenderInfoUT>({
    initialValues,

    validateOnMount: true,
    validationSchema: schema,

    onSubmit: (values, { setSubmitting }) => {
      dispatch(
        setDeliverySenderInfoUt({
          surname: values.surname?.trim(),
          firstname: values.firstname?.trim()
        })
      );

      setSubmitting(false);
    }
  });

  const onGoBack = () => {
    dispatch(setDeliverySenderInfoUt.reset());
  };

  const checkIsValid = async () => {
    const isValid = await form.validateForm(form.values);
  };

  useEffect(() => {
    checkIsValid();

    if (!form.isValid) {
      setIsValid(false);

      return;
    }

    setIsValid(true);
  }, [form.isValid]);

  useEffect(() => {
    checkIsValid();
  }, [form.dirty]);

  return {
    form,
    isValid,
    onGoBack
  };
};

export { useAddSenderInfo };
